import React from "react";
import { FailedAgreementIcon } from "icons/action/FailedIcon";

interface FailScreenProps {
  onBackToDashboard: () => void;
}

const FailScreen: React.FC<FailScreenProps> = ({ onBackToDashboard }) => (
  <div className="w-full lg:pt-[150px] pt-[100px] lg:px-[60px] px-5">
    <div className="w-full flex-col flex items-center justify-center gap-10 text-center">
      <FailedAgreementIcon />
      <div>
        <p className="lg:text-2xl text-xl font-medium text-txtPrimary">
          Action failed
        </p>
        <p className="lg:pt-6 pt-4 lg:text-base text-sm text-txtParagraph lg:leading-[20.83px] leading-[18.23px] break-words">
          We encountered an issue while processing your request. Please try
          again later. If the problem persists, contact our support team for
          assistance.
        </p>
      </div>
      <div className="lg:text-base text-sm text-txtParagraph lg:leading-[20.83px] leading-[18.23px]">
        <div
          className="lg:text-base text-sm text-blue hover:!text-btnPrimaryHover cursor-pointer "
          onClick={onBackToDashboard}
        >
          Back to dashboard
        </div>
      </div>
    </div>
  </div>
);

export default FailScreen;
